import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importCardStatementsScreenContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "CardStatementsScreenContainer" */
                '@perpay-web/fintech/components/containers/CardStatementsScreenContainer'
            ),
    );
